import React, {useEffect, useState} from 'react'
import AcceptButton from "../../Components/Main/AcceptButton";
import AddLessonButton from "../../Components/Main/AddLessonButton";
import AddLessonButtonText from "../../Components/Main/AddLessonButtonText";
import AddLessonButtonWrapper from "../../Components/Main/AddLessonButtonWrapper";
import InviteListWrapper from "../../Components/Main/InviteListWrapper";
import InviteWrapper from "../../Components/Main/InviteWrapper";
import LessonDate from "../../Components/Main/LessonDate";
import LessonDayOfTheWeek from "../../Components/Main/LessonDayOfTheWeek";
import LessonGroup from "../../Components/Main/LessonGroup";
import LessonGroups from "../../Components/Main/LessonGroups";
import LessonItem from "../../Components/Main/LessonItem";
import LessonItemActionTrigger from "../../Components/Main/LessonItemActionTrigger";
import LessonItemActions from "../../Components/Main/LessonItemActions";
import LessonItemActionsPopup from "../../Components/Main/LessonItemActionsPopup";
import LessonItemActionsPopupItem from "../../Components/Main/LessonItemActionsPopupItem";
import LessonItemLength from "../../Components/Main/LessonItemLength";
import LessonItemName from "../../Components/Main/LessonItemName";
import LessonItemNext from "../../Components/Main/LessonItemNext";
import LessonItemParticipants from "../../Components/Main/LessonItemParticipants";
import LessonItemRecurring from "../../Components/Main/LessonItemRecurring";
import LessonItemStatus from "../../Components/Main/LessonItemStatus";
import LessonItemTime from "../../Components/Main/LessonItemTime";
import LessonLeft from "../../Components/Main/LessonLeft";
import LessonList from "../../Components/Main/LessonList";
import LessonListHeading from "../../Components/Main/LessonListHeading";
import LessonListHeadingName from "../../Components/Main/LessonListHeadingName";
import LessonListHeadingWrapper from "../../Components/Main/LessonListHeadingWrapper";
import LessonLoading from "../../Components/Main/LessonLoading";
import LessonNav from "../../Components/Main/LessonNav";
import LessonNavArrowBack from "../../Components/Main/LessonNavArrowBack";
import LessonNavArrowForward from "../../Components/Main/LessonNavArrowForward";
import LessonNavArrows from "../../Components/Main/LessonNavArrows";
import LessonNavArrowsDates from "../../Components/Main/LessonNavArrowsDates";
import LessonRight from "../../Components/Main/LessonRight";
import LessonToday from "../../Components/Main/LessonToday";
import Loader from "../Loader";
import Modal from './Modals/Modal';
import MuzeLogo from "../../../../images/logo.svg";
import StyledLogo from "../../Components/Main/StyledLogo";
import WelcomeInner from "../../Components/Main/WelcomeInner";
import WelcomeWrapper from "../../Components/Main/WelcomeWrapper";
import api from '../../../util/api';
import moment from 'moment';
import LessonDetails from "./LessonDetails";
import LessonDetailsRight from "./LessonDetailsRight";
import ShareBanner from './ShareBanner';

export default ({lessons, openSessionModal, isInstructor, loggedInUser, fetchLessons, openDeleteSessionModal}) => {
    const [invites, setInvites] = useState([]);
    const [lessonsLoading, setLessonsLoading] = useState(false);
    const [firstDate, setFirstDate] = useState(moment());
    const [actionsMenu, setActionsMenu] = useState(null);
    useEffect(() => {
        api().get('/student-invites')
            .then(resp => setInvites(resp.data.data));
    }, []);
    useEffect(() => {
        setLessonsLoading(false);
    }, [lessons]);

    const acceptInvite = (uuid) => {
        api().post(`/student-invite/${uuid}/accept`)
            .then(() => {
                setInvites(prev => prev.filter(invite => invite.uuid !== uuid));
            })
            .catch((error) => {
                console.error('Failed to accept invite', error);
            });
    };

    const declineInvite = (uuid) => {
        api().post(`/student-invite/${uuid}/decline`)
            .then(() => {
                setInvites(prev => prev.filter(invite => invite.uuid !== uuid));
            })
            .catch((error) => {
                console.error('Failed to decline invite', error);
            });
    };


    return (
        <WelcomeWrapper>
            {invites.length > 0 && (
                <Modal open={true}>
                    <h2>You have pending invites.</h2>
                    <p>The following instructors want to add you to their students.</p>
                    <InviteListWrapper>
                        {invites.map((invite) => (
                            <InviteWrapper>
                                <h4>{invite.instructor_name}</h4>
                                <div>
                                    <AcceptButton onClick={(e) => {
                                        e.preventDefault()
                                        acceptInvite(invite.uuid);
                                    }}>Accept</AcceptButton>
                                    <button onClick={(e) => {
                                        e.preventDefault();
                                        declineInvite(invite.uuid);
                                    }}>Decline
                                    </button>
                                </div>
                            </InviteWrapper>
                        ))}
                    </InviteListWrapper>
                </Modal>
            )}
            <ShareBanner isInstructor={isInstructor} />
            <WelcomeInner>
                <StyledLogo src={MuzeLogo} alt="Muze"/>
                <LessonListHeadingWrapper>

                    <LessonListHeading>
                        Hi <LessonListHeadingName>{loggedInUser ? loggedInUser.name : ''}</LessonListHeadingName>!
                        Here are This Week's Lessons
                    </LessonListHeading>
                </LessonListHeadingWrapper>
                <LessonList>

                    <LessonLoading open={lessonsLoading}><i
                        className="fa fa-spinner"></i></LessonLoading>
                    <LessonNav>
                        <LessonNavArrows>
                            <LessonNavArrowBack onClick={() => {
                                fetchLessons(firstDate.clone().subtract(1, 'week').format('MMM D Y'));
                                setFirstDate(firstDate.clone().subtract(1, 'week'));
                            }}><i className="fa fa-angle-left"></i></LessonNavArrowBack>
                            <LessonNavArrowsDates>{firstDate.clone().format('MMM D') + ' - ' + firstDate.clone().add(6, 'days').format('D, Y')}</LessonNavArrowsDates>
                            <LessonNavArrowForward onClick={() => {
                                fetchLessons(firstDate.clone().add(1, 'week').format('MMM D Y'));
                                setFirstDate(firstDate.clone().add(1, 'week'));
                            }}><i className="fa fa-angle-right"></i></LessonNavArrowForward>
                        </LessonNavArrows>
                        <AddLessonButtonWrapper
                            hidden={!isInstructor || (loggedInUser && !loggedInUser.can_access_platform)}
                            onClick={() => {
                                openSessionModal()
                            }}>
                            <AddLessonButtonText
                                hidden={!isInstructor || (loggedInUser && !loggedInUser.can_access_platform)}>Schedule
                                New Event</AddLessonButtonText>
                            <AddLessonButton
                                hidden={!isInstructor || (loggedInUser && !loggedInUser.can_access_platform)}>+</AddLessonButton>
                        </AddLessonButtonWrapper>
                    </LessonNav>
                    <LessonGroups>
                        {lessons && loggedInUser && loggedInUser.can_access_platform && (
                            Object.entries(lessons || {}).map((group) => {
                                    return (
                                        <>
                                            <LessonGroup
                                                className={(moment(group[0]).format("M-D-Y") === moment().format("M-D-Y")) ? 'today' : ''}>
                                                <LessonLeft>
                                                    <LessonDayOfTheWeek>{moment(group[0]).format("ddd")}</LessonDayOfTheWeek>
                                                    <LessonDate>{moment(group[0]).format("D")}</LessonDate>
                                                    <LessonToday className="lesson-today">Today</LessonToday>
                                                </LessonLeft>
                                                <LessonRight>
                                                    {Object.entries(group[1]).map((value, value_index) => (
                                                            <LessonItem className={value_index === 0 ? 'first-lesson' : ''}>
                                                                { value[1].is_next && <LessonItemNext>NEXT</LessonItemNext> }
                                                                <LessonDetails>
                                                                    <LessonItemName
                                                                        href={'/lesson/' + value[1].uuid} key={value[1].id}
                                                                        className="lesson-item-name">
                                                                        <div className="inner">{value[1].label}</div>
                                                                    </LessonItemName>
                                                                    <LessonDetailsRight>
                                                                        <LessonItemParticipants
                                                                            className="lesson-item-participants">
                                                                            With {value[1].participant_string}
                                                                        </LessonItemParticipants>
                                                                        <LessonItemTime className="lesson-item-time">
                                                                            <i className="fa fa-clock"></i>
                                                                            {value[1].time_timezoned} {value[1].time_end ? ' - ' + value[1].time_end : ''}
                                                                        </LessonItemTime>
                                                                        <LessonItemRecurring className="lesson-item-recurring"
                                                                                             hidden={value[1].recurring === ''}>
                                                                            <i className="fa fa-retweet"></i>
                                                                            {value[1].recurring}</LessonItemRecurring>
                                                                        <LessonItemLength className="lesson-item-length">1
                                                                            Hour</LessonItemLength>
                                                                        <LessonItemStatus online={value[1].status !== ''}>
                                                                            {value[1].status}
                                                                        </LessonItemStatus>
                                                                        <LessonItemActions>
                                                                            <LessonItemActionsPopup
                                                                                hidden={actionsMenu !== value[1].id}>
                                                                                <LessonItemActionsPopupItem onClick={(e) => {
                                                                                    e.preventDefault();
                                                                                    const cal_url = new URL('http://www.google.com/calendar/event')
                                                                                    cal_url.searchParams.set('action', 'TEMPLATE')
                                                                                    cal_url.searchParams.set('dates', value[1].calendar_value)
                                                                                    cal_url.searchParams.set('text', value[1].label)
                                                                                    cal_url.searchParams.set('ctz', 'America/New_York')
                                                                                    if(!!value[1].recurring){
                                                                                        cal_url.searchParams.set('recur', `RRULE:FREQ=${value[1].recurring.toUpperCase()};COUNT=${value[1].recurring_session_occurrences}`)
                                                                                    }
                                                                                    window.open(cal_url.toString(), '_blank')
                                                                                }}>
                                                                                    <i className="fas fa-calendar"></i>
                                                                                    Add to Calendar
                                                                                </LessonItemActionsPopupItem>
                                                                                <LessonItemActionsPopupItem onClick={(e) => {

                                                                                    e.preventDefault();
                                                                                    openDeleteSessionModal(value[1].uuid);
                                                                                }} hidden={!isInstructor}>

                                                                                    <i className="fas fa-trash"></i>
                                                                                    Delete Lesson</LessonItemActionsPopupItem>
                                                                            </LessonItemActionsPopup>
                                                                            <LessonItemActionTrigger
                                                                                onClick={() => {
                                                                                    setActionsMenu(value[1].id === actionsMenu ? null : value[1].id)
                                                                                }}>
                                                                                .<br/>.<br/>.
                                                                            </LessonItemActionTrigger>
                                                                        </LessonItemActions>
                                                                    </LessonDetailsRight>
                                                                </LessonDetails>
                                                            </LessonItem>
                                                    ))}
                                                </LessonRight>
                                            </LessonGroup>
                                        </>
                                    )
                                }
                            )
                        )}
                    </LessonGroups>
                </LessonList>
            </WelcomeInner>
        </WelcomeWrapper>
    )
};
